import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Breadcrumb } from './breadcrumb.interface';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  public subject = new Subject();
  public breadcrumbActionPerformed = new Subject();
  public items: Breadcrumb;
  count: any = '';

  constructor() {
    this.subject.next({});
    this.breadcrumbActionPerformed.next({});
  }

  get onInit(): Observable<any> {
    return this.subject.asObservable();
  };

  setItems(itemsList: Breadcrumb): void {
    this.items = itemsList;
    this.subject.next(this.items);
  }


  serializeSDKConfig(config: any): any {
    if (!config) { return; }

    const ui = config.params['ui.create'][0];
    const serializedConfig = {
      id: ui.id,
      displayName: ui.title,
      displayKey: ui.title,
      type: ui.buttonType,
      icon: ui.icon ? `ti ti-${ui.icon}` : '',
      style: ui.className,
      showIf: true,
    };
    if (ui.type === 'DROPDOWN') {
      serializedConfig['children'] = ui['children'].map((item: any) => ({
        id: item.id,
        displayName: item.title,
        displayKey: item.title,
        type: 'SINGLE',
        icon: item.icon ? `ti ti-${item.icon}` : '',
        style: item.className,
        showIf: true,
      }));
    }
    return serializedConfig;
  }

  addExisitingButtonFromSDK(btnList: any[], buttonsFromSDK: any[], currentSDKButtonConfigs: any[]): any[] {
    buttonsFromSDK.forEach((btnConfig: any) => {
      const ui = btnConfig.params['ui.create'][0];
      let serializedConfig = this.serializeSDKConfig(btnConfig);
      const isButtonAlreadyExists = currentSDKButtonConfigs.findIndex((btnConfig: any) => btnConfig.id === serializedConfig.id);
      if(isButtonAlreadyExists !== -1){
        serializedConfig = {
          ...serializedConfig,
          ...currentSDKButtonConfigs[isButtonAlreadyExists]
        }
      }
      if (ui.position === 'left') {
        btnList.splice(0,0, serializedConfig);
      }else{
        btnList.push(serializedConfig);
      }
    });
    return btnList;
  }

}
